import { render, staticRenderFns } from "./SurveyTakeFinal.vue?vue&type=template&id=2f4f64f0&scoped=true"
import script from "./SurveyTakeFinal.vue?vue&type=script&lang=js"
export * from "./SurveyTakeFinal.vue?vue&type=script&lang=js"
import style0 from "./SurveyTakeFinal.vue?vue&type=style&index=0&id=2f4f64f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4f64f0",
  null
  
)

export default component.exports